import styled, { css } from 'styled-components'

export const StyledContainerProjectsFilters = styled.div`
    ${({ theme, widht }) => css`
        display: grid;
        grid-template-columns: 130px 170px 170px ${widht};
        gap: ${theme.spacing}px;
    `}
`
